import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const AMENITIES = {
  ROOT: `${PRIVATE_ROOT}/community/amenities`,
  UPCOMING: `${PRIVATE_ROOT}/community/amenities/upcoming-reservations`,
}

export const SUITE_AMENITIES = {
  ROOT: `${PRIVATE_ROOT}/suite/amenities`,
  UPCOMING: `${PRIVATE_ROOT}/suite/amenities/upcoming-reservations`,
}

export const VIEW_AMENITY = `${PRIVATE_ROOT}/community/amenities/:id/view`
export const VIEW_RESERVATION = `${PRIVATE_ROOT}/community/amenities/upcoming-reservation/:id`
export const VIEW_AMENITY_DETAILS = `${PRIVATE_ROOT}/community/amenities/view-amenity-details/:id`
export const VIEW_MULTIDAY_RESERVATION = `${PRIVATE_ROOT}/community/amenities/multi-day-reservation/:id`
